export default __webpack_public_path__ + "static/og-a43bc1e8af9e3fff79fee43cd6564fc84395c3aba23fc5577bfdad1bea9efd86.png";